import { FC } from 'react';

import CoverUploadModal from '../../../../../common/CoverUploadModal/CoverUploadModal';
import { useUploadTripCustomCoverMutation } from '../../../../../store/services/tripsApi';

type TripCoverUploadModalProps = {
  open: boolean;
  tripId: number;
  onClose: () => void;
  onSuccess?: () => void;
};

const TripCoverUploadModal: FC<TripCoverUploadModalProps> = ({ open, tripId, onClose, onSuccess }) => {
  const [uploadTripCover] = useUploadTripCustomCoverMutation();

  return (
    <CoverUploadModal
      open={open}
      onClose={onClose}
      title="Update Trip Cover"
      description="Choose a new image for your trip cover."
      placeholder={{
        title: 'Select your trip cover',
        subtitle: '(e.g., PNG, JPG, GIF up to 5MB)',
      }}
      uploadFile={file =>
        uploadTripCover({ tripId, file })
          .unwrap()
          .then(() => {
            onSuccess?.();
          })
      }
    />
  );
};

export default TripCoverUploadModal;
